// @flow
import type {GridColDef, GridActionsColDef} from '@mui/x-data-grid';
import moment from 'moment';
import {Typography} from '@wellstone-solutions/web';
import type {Member} from 'api/v2';

import {getIdentity} from 'utils/Forms';
import {NavigationCell} from 'modules/datagrid';
import {MemberProfileCell} from './MemberProfileCell';
import {ViewProfile, ResendInvitation, CreateDocumentation} from './actions';
// TODO - Replace any type with ProgramAdmission after api-client is updated
type MemberListColumns = {
  name: GridColDef<any>,
  lastAppOpen: GridColDef<any>,
  startDate: GridColDef<any>,
  endDate: GridColDef<any>,
  dateProfileCreated: GridColDef<any>,
  ehr: GridColDef<any>,
  mobile: GridColDef<any>,
  getRowActions: ({
    onResendInvite: (member: Member) => void,
  }) => GridActionsColDef<any>,
};

export const memberListColumns: MemberListColumns = {
  name: {
    field: 'member__name',
    headerName: 'Name',
    flex: 1,
    minWidth: 200,
    renderCell: ({row}) => {
      const identity = getIdentity(row.member.identifiesAs);

      return (
        <NavigationCell
          to={`/members/${row.member.id}`}
          text={row.member.name}
          subText={identity.name}
        />
      );
    },
  },
  lastAppOpen: {
    field: 'lastAppOpen',
    headerName: 'Last App Opened',
    minWidth: 115,
    flex: 0.5,
    valueGetter: ({row}) => {
      const lastAppOpen = row.member.data?.lastAppOpen;
      return lastAppOpen
        ? moment(lastAppOpen).format('MMM D, YYYY')
        : 'Never opened app';
    },
  },
  startDate: {
    field: 'startDate',
    headerName: 'Start Date',
    minWidth: 115,
    flex: 0.5,
    valueFormatter: ({value}) =>
      value ? moment(value).format('MMM D, YYYY') : '',
  },
  endDate: {
    field: 'endDate',
    headerName: 'End Date',
    minWidth: 115,
    flex: 0.5,
    valueFormatter: ({value}) =>
      value ? moment(value).format('MMM D, YYYY') : '',
  },
  dateProfileCreated: {
    field: 'created',
    headerName: 'Date Profile Created',
    minWidth: 115,
    flex: 0.5,
    valueGetter: ({row}) => row.member.created,
    valueFormatter: ({value}) =>
      value ? moment(value).format('MMM D, YYYY') : '',
  },
  ehr: {
    field: 'ehrId',
    headerName: 'EHR System',
    minWidth: 140,
    renderCell: ({row}) => {
      return row.member.data.ehr ? (
        <Typography>{row.member.data.ehr}</Typography>
      ) : (
        <Typography sx={{color: 'red.main', fontSize: 14, fontWeight: 'bold'}}>
          Not connected
        </Typography>
      );
    },
  },
  mobile: {
    field: 'mobile',
    headerName: '',
    minWidth: 150,
    flex: 1.5,
    renderCell: ({row}) => {
      return <MemberProfileCell member={row.member} />;
    },
  },
  getRowActions: ({onResendInvite}) => ({
    field: 'actions',
    headerName: 'Actions',
    type: 'actions',
    flex: 1,
    maxWidth: 90,
    getActions: ({row}) => [
      <ViewProfile showInMenu={true} member={row.member} />,
      <ResendInvitation
        showInMenu={true}
        member={row.member}
        onClick={onResendInvite}
      />,
      <CreateDocumentation showInMenu={true} member={row.member} />,
    ],
  }),
};
